export default "__VITE_ASSET__Cu66fvu$__"